// removed by extract-text-webpack-plugin
module.exports = {"root":"Social__root___2FAkT","item":"Social__item___1LMYg","icon":"Social__icon___1HUAX","inline":"Social__inline___zzw7e","text":"Social__text___1yLb7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Social/Social.css
// module id = 101
// module chunks = 0